import {
  PostComisionMembresiaCargaMetas,
  GetComisionMembresiaMetas,
  GetComisionMembresiaMetasActuales
} from "../../../reducers/comisionMembresia";

export interface ConfiguracionMetasStore
  extends PostComisionMembresiaCargaMetas,
    GetComisionMembresiaMetas,
    GetComisionMembresiaMetasActuales {}

export const configuracionMetasStore: (
  state
) => ConfiguracionMetasStore = state => {
  const comisionMembresiaState = state.comisionMembresia;

  return {
    cargaMembresiaMeta: comisionMembresiaState.cargaMembresiaMeta,
    postingCargaMembresiaMeta: comisionMembresiaState.postingCargaMembresiaMeta,
    postingCargaMembresiaMetaError:
      comisionMembresiaState.postingCargaMembresiaMetaError,

    comisionMembresiaMetas: comisionMembresiaState.comisionMembresiaMetas,
    gettingComisionMembresiaMetas:
      comisionMembresiaState.gettingComisionMembresiaMetas,
    gettingComisionMembresiaMetasError:
      comisionMembresiaState.gettingComisionMembresiaMetasError,

    comisionMembresiaMetasActuales:
      comisionMembresiaState.comisionMembresiaMetasActuales,
    gettingComisionMembresiaMetasActuales:
      comisionMembresiaState.gettingComisionMembresiaMetasActuales,
    gettingComisionMembresiaMetasActualesError:
      comisionMembresiaState.gettingComisionMembresiaMetasActualesError
  };
};
